import { Buffer } from 'buffer';

export const decrypt = (data: string) => {
    try {
        const raw = decodeURIComponent(data);
        return Buffer.from(raw, 'base64').toString('utf8');
    } catch (_) {
        return Buffer.from(data || '', 'base64').toString('utf8');
    }
};

export const encrypt = (data: any) => {
    const b64 = Buffer.from(JSON.stringify(data), 'utf8').toString('base64');
    return encodeURIComponent(b64);
};
